import { useLocation, useNavigate } from 'react-router-dom';
import { Home, MessageCircle, Target, BarChart2, HeartHandshake } from 'lucide-react';
import { motion } from 'framer-motion';

const navItems = [
  { path: '/dashboard', icon: Home, label: 'Home' },
  { path: '/coach', icon: MessageCircle, label: 'Coach360' },
  { path: '/habits', icon: Target, label: 'Habits' },
  { path: '/trends', icon: BarChart2, label: 'Trends' },
  { path: '/care', icon: HeartHandshake, label: 'Care' },
];

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 h-20 bg-card/90 backdrop-blur-lg border-t border-border flex justify-around items-center z-50 px-2">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
        const Icon = item.icon;

        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className="relative flex flex-col items-center justify-center w-16 h-16 rounded-2xl transition-colors"
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            {isActive && (
              <motion.div
                layoutId="nav-indicator"
                className="absolute inset-0 bg-primary/10 rounded-2xl"
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              />
            )}
            <Icon
              size={22}
              className={`relative z-10 transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
            />
            <span
              className={`text-[10px] mt-1 relative z-10 transition-colors ${
                isActive ? 'text-primary font-medium' : 'text-muted-foreground'
              }`}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
